import React, { useState, useEffect } from "react";

import queryString from "query-string";
import API_URL from "../components/ApiUrl";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VerifyAccountDeleted = () => {
  const navigate = useNavigate();
  const [httpStatus, setHttpStatus] = useState(500);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const parsed = queryString.parse(window.location.search);
  // console.log(parsed);
  const token = parsed.token;

  useEffect(() => {
    fetch(`${API_URL}/users/confirm-deletion`, {
      body: JSON.stringify({
        token: token,
      }),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        console.log(response);
        setHttpStatus(response.status);
      })
      .catch((error) => {
        console.error(error);
        setHttpStatus(401);
      })
      .finally(() => setLoading(false)); // Set loading to false regardless of fetch outcome
  }, [token]);

  if (loading) {
    return (
      <div className="content">
        <p>Loading...</p>
      </div>
    );
  } else if (httpStatus === 204) {
    return (
      <div className="content">
        {/* <img src={successIcon} className="Leader-icon" alt="Success" /> */}
        <h1 style={{ color: "red" }}>{t("delete.success.title")}</h1>
        <br />
        <p>
          {t("delete.success.body.1")}
          <br /> <br />
          {t("delete.success.body.2")} <br />
          {t("delete.success.body.3")}{" "}
        </p>
        <br />
        <br />
        <p>{t("contact_support.title")}</p>
        <a href="tel:0800300766">{t("contact_support.body")}</a>
        <br />
        <p>
          {t("thank.1")} <br />
          {t("thank.2")}{" "}
        </p>
      </div>
    );
  } else {
    return (
      <div className="content">
        {/* <img src={failIcon} className="Leader-icon" alt="Fail" /> */}
        <h1 style={{ color: "red" }}>{t("delete.fail.title")}</h1>
        <p>
          {t("delete.fail.body.1")} <br />
          {t("delete.fail.body.2")}{" "}
        </p>
        <button
          className="submit"
          onClick={() => navigate("/delete-account")}
        >
          {t("delete.fail.btn")}
        </button>
        <br />
        <br />
        <p>{t("contact_support.title")}</p>
        <a href="tel:0800300766">{t("contact_support.body")}</a>
        <br />
        <p>
          {t("thank.1")} <br />
          {t("thank.2")}{" "}
        </p>
      </div>
    );
  }
};

export default VerifyAccountDeleted;
